// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2ucnI","validationTips":"StatementDescriptor_validationTips__29ADY"};